import domready from 'domready'

import { addNativeEvent, removeNativeEvent, jQueryObject, deferJquery, debugLog } from '../common/utils'
import { airbrakeNotify } from '../common/airbrake'
import { ajax } from '../common/ajax'
import { formData } from '../common/formData'

export function bindForms() {
  domready(() => {
    deferJquery(
      () => {
        jQueryObject().each(
          jQueryObject()('form'),
          function(k, v) {
            debugLog('JQuery binding form:', v)
          }
        )

        jQueryObject()('form:not(#jensen_modal_form)').submit(function(e) {
          onJquerySubmit(e)
        })
      },
      () => {
        document.querySelectorAll('form:not(#jensen_modal_form)').forEach(form => {
          debugLog('Native binding form:', form)
          addNativeEvent(form, 'submit', onNativeSubmit)
        })
      },
      0, 1000
    )
  })
}

export function trackLead(leadDataArr, formId, successCb, errorCb) {
  let leadData = { lead_page: window.location.href }
  leadDataArr.forEach(el => { leadData[el.name] = el.value })

  submitLead(
    {
      form_id: formId,
      site_id: JENSEN_SITE_ID,
      lead: { source: document.referrer, lead_data: leadData }
    },
    function(res) {
      if (res.redirect_url) {
        window.location = res.redirect_url
      }

      typeof successCb === 'function' && successCb.call(this, res)
    },
    function (xhr) {
      airbrakeNotify(`trackLead Submit: ${this}: ${xhr.statusText}`)
      typeof errorCb === 'function' && errorCb()
    }
  )
}

function callback(res) {
  debugLog('Jensen lead response', res)

  if (res.submit_form) {
    if (jQueryObject()) {
      jQueryObject()(this).unbind('submit')
    } else {
      removeNativeEvent(this, 'submit', onNativeSubmit)
    }

    this.submit()
  } else {
    this.reset()
    if (res.redirect_url) window.location = res.redirect_url
  }
}

function onNativeSubmit(e) {
  e.preventDefault()

  submitLead(
    collectData(this),
    callback.bind(this),
    function (xhr) { airbrakeNotify(`Native Submit: ${this}: ${xhr.statusText}`) }
  )
}

function onJquerySubmit(e) {
  e.preventDefault()
  let form = e.target

  submitLead(
    collectData(form),
    callback.bind(form),
    function (xhr) { airbrakeNotify(`Jquery Submit: ${this}: ${xhr.statusText}`) }
  )
}

export function submitLead(data, successCb, errorCb) {
  if (Object.keys(data.lead.lead_data).length) {
    ajax({
      method: 'POST',
      url: process.env.JENSEN_LEADS_ENDPOINT,
      data: data,
      successCb,
      errorCb
    })
  }
}

export function collectData(form) {
  return {
    site_id: JENSEN_SITE_ID,
    form_id: form.id,
    lead: {
      source: document.referrer,
      lead_data: formData(form)
    }
  }
}



// WEBPACK FOOTER //
// ./app/js/bind_forms.js